__turbopack_context__.v({
  "bluePrimary": "ColourCombinations-module__WVTozG__bluePrimary",
  "blueSecondary": "ColourCombinations-module__WVTozG__blueSecondary",
  "blueTertiary": "ColourCombinations-module__WVTozG__blueTertiary",
  "defaultBackground": "ColourCombinations-module__WVTozG__defaultBackground",
  "greenPrimary": "ColourCombinations-module__WVTozG__greenPrimary",
  "greenSecondary": "ColourCombinations-module__WVTozG__greenSecondary",
  "greenTertiary": "ColourCombinations-module__WVTozG__greenTertiary",
  "greyPrimary": "ColourCombinations-module__WVTozG__greyPrimary",
  "greySecondary": "ColourCombinations-module__WVTozG__greySecondary",
  "greyTertiary": "ColourCombinations-module__WVTozG__greyTertiary",
  "yellowPrimary": "ColourCombinations-module__WVTozG__yellowPrimary",
  "yellowSecondary": "ColourCombinations-module__WVTozG__yellowSecondary",
  "yellowTertiary": "ColourCombinations-module__WVTozG__yellowTertiary",
});
